(function(window, document, $){

	overwatch.buy = overwatch.buy || {};
	overwatch.buy.navigation = overwatch.buy.navigation || {};
	overwatch.buy.navigation.init = function init() {
		var $nav = $('.edition-select');
		var $active = $nav.children('.active');
		var $thing = $active.children('.active-splash');
		var Mediator = window.overwatch.BuyMediator;
		var util = window.overwatch.util;

		// get the window offset value for resolutions > 2560
		function windowOffset(){
			var w = util.width();
			return w > 2560 ? (w - 2560)/2 : 0;
		};

		// set position and width of $thing
		// account for skew effect and height differences
		// http://stackoverflow.com/a/9284016
		function setPosition(opts){

			var opts = opts || { duration: 0 };

			// get active item boundingRect
			var rect = $active[0].getBoundingClientRect();

			// set new values
			// account for skew effect on boundingRect and
			// active item height being 84% of active-splash
			//debugger;
			$thing.velocity({
				left: (rect.left - windowOffset()),// + ((Math.tan(0.25) * (rect.height * 0.84)) / 2),
				width: $active[0].clientWidth
			}, opts);
		};

		if(typeof $thing[0] !== 'undefined') {
			// wait till DOM is ready before reading boundingRect values
			$(document).on('ready', function(event){

				// get initial boundingRect
				var rect = $thing[0].getBoundingClientRect();

				// account for the transform skew affect on boundingRect
				// clientWidth to get actual width without skew affect on boundngRect
				$thing.velocity({
					left: (rect.left - windowOffset()), // + ((Math.tan(0.25) * rect.height) / 2),
					width: $thing[0].clientWidth
				}, {
					duration: 0,
					complete: function(){

						// append to the navigation container
						// after setting values is complete
						// or sometimes we get fouc
						$thing = $thing.appendTo($nav.parent());
					}
				});


				// handle nav item clicks
				Mediator.on("ow.sku.change", function(sku){

					// set current active tab
					$active = $nav.find("[data-sku-change='" + sku.id + "']");


					// set the new position/ width
					setPosition({ duration: 200, easing: 'easeOutQuad' });
				});

				// set resize event after document.ready becuase some browsers
				// trigger a resize event at an earlier time
				// and we would get incorrect values set on the object
				$(window).on('resize', function(){

					// set the new position/ width
					setPosition();
				});

				// update position on buy form open and close
				$(document).on('ow.buy.form.show ow.buy.form.hide', function(){

					// set the new position/ width
					setPosition();
				});

			});
		}
	};

})(window, window.document, window.jQuery);
